var origTables;
$(document).ready(function(){
	if ($("html").attr("data-bank") == "CIB") {
	var tables = $("div[data-type-tables]");
	origTables = tables.clone();
	$(tables).each(function(index){
		var table = $(this);
		var tableType = table.attr("data-type-tables");
		var endpoint = window.location.origin + $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint").val();
		getJsonAjaxs(endpoint, $("#exchange-rates-"+tableType.toLowerCase()), tableType);
		//createTable(tableType); solo se si mock
	});
	}
});

setValidationDateInpage = function(data){
	if($('.-js-date-exchange').length == 1) {
		$('.-js-date-exchange').html(
			moment(data.rates[0].validFromDate).locale('en').format('YYYY.MM.DD HH:mm')
		);
	}
}

createTables = function(tableType){
	var ratioLabel = $("#data-label-ratio").val();
	var sellLabel = $("#data-label-sell").val();
	var middleLabel = $("#data-label-middle").val();
	var buyLabel = $("#data-label-buy").val();
	var hiddenColumnBuy = $("#data-ecb-hiddend-column-buy").val();
	var hiddenColumnSell = $("#data-ecb-hiddend-column-sell").val();
	var hiddenColumnMiddle = $("#data-ecb-hiddend-column-middle").val();
	var hiddenColumnRatio = $("#data-ecb-hiddend-column-ratio").val();
	var lang= $("html").attr("lang");
	var jsonToFormat = $("#ecb-rates").val();
	//var jsonToFormatMock = $("#exchange-rates-"+tableType.toLowerCase()).val();
	var jsonFormatted = '{"0":{"' + jsonToFormat.slice(jsonToFormat.indexOf("Cube"));
	console.log($("div[data-type-tables]").length);
	var table = $("div[data-type-tables=STANDARD]");
	var indexForEcbArchive = 0;
	var json = $("#exchange-rates-standard").val();
	var jsonEcb = JSON.parse(jsonFormatted);
	setValidationDateInpage(JSON.parse(json));
		if(json != ""){
			var obj = JSON.parse(json);
			var clonedTable = table.clone();
			var columnsList = table.find("ul.tbl2__highlist");
			var columnsRow = columnsList.find("li.tbl2__highlistItem");
			var wrapper = columnsRow.find("div.tbl__textWrapper");
			var columnsRowList = wrapper.find("ul.tbl__highlist");
			var columns = columnsRowList.find("li.tbl__highlistItem");
			var totalColumns = 5 ;
		    console.log(totalColumns);
		    columnsRowList.html("");
		    columnsList.html("");
		    $.each(obj.rates, function(key, value) {
		   	     	var clonedRow = columnsRow.clone();
		   	     	console.log(value);
		   		    var jsonValue = value;
		   	        var columnsRowListCloned = columnsRowList.clone();
		   	        var clonedWrapper = wrapper.clone();
		   	        var valueResult ="";
		   	        var valueResultLabel = "";
		   	        var currencyFrom = jsonValue.fromCurrency;
		   	        var currencyFromLabel = currencyFrom.label.toUpperCase();
		   	        var currencyTo = jsonValue.toCurrency;
				    var currencyToLabel = currencyTo.label;
   		    		if(currencyToLabel != "KWD"){
   		    			for(i = 0; i <totalColumns; i++){
   		    				var cloned = columns.clone();

		   		    	switch(i) {
		   		    	  case 0:
		   		    		valueResult = currencyToLabel;
		   		    	    clonedWrapper.append('<div class="tbl__title" >'+valueResult+'</div>');
		   		    	    if(lang == "hu" ){
		   		    	    	switch(valueResult){
			   		    	     
						   		    	case "AUD":
						   		    	    valueResult = "ausztrál dollár" ;
						   		    		break;
						   		    	case "CAD":
						   		    	 valueResult = "kanadai dollár" ;
						   		    		break;
						   		    	case "CHF":
						   		    	 valueResult = "svájci frank";
						   		    		break;
						   		    	case "CZK":
						   		    	 valueResult = "cseh korona";
						   		    		break;
						   		    	case "DKK":
						   		    	 valueResult ="dán korona";
						   		    		break;
						   		    	case "EUR":
						   		    	 valueResult = "euró";
						   		    		break;
						   		    	case "GBP":
						   		    	 valueResult = "brit font";
						   		    		break;
						   		    	case "HRK":
						   		    	 valueResult = "horvát kuna";
						   		    		break;
						   		    	case "JPY":
						   		    	 valueResult =  "japán jen (100)";
						   		    		break;
						   		    	case "NOK":
						   		    	 valueResult =  "norvég korona";
						   		    		break;
						   		    	case "PLN":
						   		    	 valueResult = "lengyel zloty";
						   		    		break;
						   		    	case "RON":
						   		    	 valueResult = "román lej";
						   		    		break;
						   		    	case "SEK":
						   		    	 valueResult = "svéd korona";
						   		    		break;
						   		    	case "USD":
						   		    	 valueResult = "USA-dollár";
						   		    		break;
				   		    		
				   		    	default :
				   		    		break;
				   		      	}		   		    	    
		   		    	    }else{
		   		    	    	switch(valueResult){
			   		    	     
				   		    	case "AUD":
				   		    	    valueResult = "Australian Dollar" ;
				   		    		break;
				   		    	case "CAD":
				   		    	 valueResult = "Canadian Dollar" ;
				   		    		break;
				   		    	case "CHF":
				   		    	 valueResult = "Swiss Franc";
				   		    		break;
				   		    	case "CZK":
				   		    	 valueResult ="Czech Koruna";
				   		    		break;
				   		    	case "DKK":
				   		    	 valueResult ="Danish Krone";
				   		    		break;
				   		    	case "EUR":
				   		    	 valueResult = "Euro";
				   		    		break;
				   		    	case "GBP":
				   		    	 valueResult = "Pound Sterling";
				   		    		break;
				   		    	case "HRK":
				   		    	 valueResult ="Croatian Kuna";
				   		    		break;
				   		    	case "JPY":
				   		    	 valueResult =  "Yen";
				   		    		break;
				   		    	case "NOK":
				   		    	 valueResult =  "Norwegian Krone";
				   		    		break;
				   		    	case "PLN":
				   		    	 valueResult = "Zloty";
				   		    		break;
				   		    	case "RON":
				   		    	 valueResult = "Romanian Leu";
				   		    		break;
				   		    	case "SEK":
				   		    	 valueResult = "Swedish Krona";
				   		    		break;
				   		    	case "USD":
				   		    	 valueResult = "US Dollar";
				   		    		break;
				   		    		
				   		    	default :
				   		    		break;
				   		    	     
				   		       }		   		  
		   		    	    }
		   		    	    clonedWrapper.append('<div class="tbl__label" >'+valueResult+'</div>');
		   		    	    break;
		   		    	  case 1:
		   		    		 if(hiddenColumnBuy == "false"){
		   		    			 valueResult = jsonValue.buyRate.rate;
		   		    			 valueResultLabel = buyLabel;
		   		    		 }else{
		   		    			valueResult = "false";
		   		    		 }
		   			    	    break;
		   		    	  case 2:
		   		    		if(hiddenColumnMiddle == "false"){
		   		    		  valueResult = jsonValue.meanRate.rate;
		   		    		  valueResultLabel = middleLabel;
		   		    		 }else{
		   		    			valueResult = "false";
		   		    		 }
		   			    	    break;
		   			  
		   		    	  case 3:
		   		   		if(hiddenColumnSell == "false"){
		   		    		 valueResult = jsonValue.sellingRate.rate;
		   		    		 valueResultLabel = sellLabel;
		   		    		 }else{
		   		    			valueResult = "false";
		   		    		 }
		   			    	    break;
		   		    		
		   		    	  case 4:
		   		    		if(hiddenColumnRatio == "false"){
			   	   		   	var cubeArray = [];
		   		    		cubeArray = jsonEcb[0].Cube.Cube.Cube;	
		   		    		var toRates = 0;
	   		    		  	var fromRates = 0;
	   		    		  	for(c = 0; c < cubeArray.length; c++){
	   		    		  		if(cubeArray[c].currency == currencyFromLabel){
	   		    		  			fromRates = cubeArray[c].rate;
	   		    		  			console.log(fromRates);
	   		    		  		}
	   		    		  		if(cubeArray[c].currency == currencyToLabel){
	   		    		  			toRates = cubeArray[c].rate;
	   		    		  			console.log(toRates);
	   		    		  		}
	   		    		  	}
	   		    		 valueResult = calculateRateFormulas(jsonValue.sellingRate.rate, fromRates, toRates, currencyToLabel);
	   		    		 valueResultLabel = ratioLabel;
		   		    		}else {
		   		    			valueResult = "false";
		   		    		}
		   			    	    break;
		   		    	  default:
		   		    	    valueResult = "";
		   		    	} 
		   		    	if (i >= 1){
		   		    		if(valueResult != "false"){
		   		    			cloned.html('<span class="tbl__highlistLabel">'+valueResultLabel+'</span><span class="tbl__highlistValue"><strong>'+valueResult+'</strong></span>');
				   		    	columnsRowListCloned.append(cloned);
				   		    	clonedWrapper.append(columnsRowListCloned);
		   		    		}
		   		    	}
		   	        }
		   		   }	
		   		    	clonedRow.append(clonedWrapper);
		   		    	
		
		   		    columnsList.append(clonedRow);
		   		});
		}

}




calculateRateFormulas = function(sellingRate, fromRates, toRates, currency){
	result = 0;	
	console.log("esegue la formula ");
		if(currency == "EUR"){
			result = (sellingRate/fromRates - 1 ) * 100;
			console.log(result);


		}else if (currency == "HUF" || 
				currency == "DKK" || 
				currency == "SEK" || 
				currency == "PLN" ||
				currency == "CZK" ||
				currency == "RON" ||
				currency == "HRK" ||
				currency == "NOK" ||
				currency == "CHF" 
				) {
			
		
			result = (sellingRate / (fromRates/toRates) -1 ) * 100;
			console.log(result);
			
		} else {
			return "-";
		}
	return Number(result).toFixed(2) + "%";
	
}

clearTable = function(tableType){
	
	$(origTables).each(function(index){
		if($(this).attr("data-type-tables") == tableType){
			$("div[data-type-tables="+tableType+"]").html('');
			$("div[data-type-tables="+tableType+"]").html($(this).html());
		}
	});
}


getJsonAjaxs = function (endpoint, element, tableType){
	console.log("invoked url: " + endpoint);	
	$.ajax({
		  method: "GET",
		  url: endpoint
		})
		.done(function( data ) {
			if(data != null){
				console.log("----" + JSON.stringify(data) +"----");
			  	$(element).val(JSON.stringify(data));
			  	console.log("element :"+element);
			  	createTables(tableType);
			}
		});
}

